import React from 'react';
import { useI18n } from '../i18n/index.jsx';

// Simple strength hint: length plus variety of character types. The only
// hard rule (server-enforced) is 8+ characters.
export function passwordScore(pw) {
  if (!pw) return 0;
  if (pw.length < 8) return 1;
  const kinds = [/[a-z]/, /[A-Z]/, /\d/, /[^A-Za-z0-9]/].filter((r) => r.test(pw)).length;
  let score = 2;
  if (pw.length >= 12) score++;
  if (kinds >= 3) score++;
  return Math.min(score, 4);
}

export default function PasswordStrength({ password }) {
  const { t } = useI18n();
  const score = passwordScore(password);
  const label = ['', 'tooShort', 'fair', 'good', 'strong'][score];
  return (
    <div className={`pw-strength pw-${score}`} aria-live="polite">
      <div className="pw-bars" aria-hidden="true">{[1, 2, 3, 4].map((i) => <span key={i} className={i <= score ? 'on' : ''} />)}</div>
      <span className="pw-label">{score ? t(`auth.strength.${label}`) : t('auth.passwordHint')}</span>
    </div>
  );
}
